"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Layout = _interopRequireDefault(require("../../components/Layout"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _Webmail = _interopRequireDefault(require("../../components/Webmail"));
var _Footer = _interopRequireDefault(require("../../components/Footer"));
var _Partner = require("../../contexts/Partner");
var _Bonus = _interopRequireDefault(require("../../components/Bonus"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Bonus = function Bonus(_ref) {
  var info = _ref.info,
    layout = _ref.layout,
    webmail = _ref.webmail,
    partner = _ref.partner,
    score_links = _ref.score_links,
    organization = _ref.organization,
    unsubscribe = _ref.unsubscribe;
  var footer = _objectSpread(_objectSpread({}, organization), unsubscribe);
  return /*#__PURE__*/_react["default"].createElement(_Partner.PartnerContextProvider, {
    value: partner
  }, /*#__PURE__*/_react["default"].createElement(_Layout["default"], layout, /*#__PURE__*/_react["default"].createElement(_Webmail["default"], webmail), /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    fullWidth: true,
    bgColor: "#fff"
  }), /*#__PURE__*/_react["default"].createElement(_Bonus["default"], (0, _extends2["default"])({}, info, {
    score_links: score_links
  })), /*#__PURE__*/_react["default"].createElement(_Footer["default"], footer)));
};
var _default = exports["default"] = Bonus;